/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiAgentEventSchema = z.enum(['activity-changed'])

export type WhatsAppAiAgentEventSchema = z.infer<typeof whatsAppAiAgentEventSchema>
